// Team colours from the competitors' shirts, shared by the MatchTracker and
// the stats charts.
const DEFAULT_HOME_COLOR = '#00e0ff';
const DEFAULT_AWAY_COLOR = '#ff3d5a';
// '#abc', '#aabbcc', 'aabbcc' -> '#aabbcc'; anything else -> null.
const normalizeHex = value => {
  if (value === null || value === undefined) return null;
  let v = String(value).trim().replace(/^#/, '');
  if (/^[0-9a-f]{3}$/i.test(v)) v = v.split('').map(c => c + c).join('');
  return /^[0-9a-f]{6}$/i.test(v) ? `#${v.toLowerCase()}` : null;
};
const hexToRgb = hex => [1, 3, 5].map(i => parseInt(hex.slice(i, i + 2), 16));
// Readable text colour on top of a team colour (dark text on light shirts).
export const contrastText = hex => {
  const [r, g, b] = hexToRgb(hex).map(c => { c /= 255; return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b > 0.55 ? '#111827' : '#ffffff';
};
const colorDistance = (a, b) => { const x = hexToRgb(a), y = hexToRgb(b); return Math.sqrt(x.reduce((s, v, i) => s + (v - y[i]) ** 2, 0)); };

// Home/away shirt colours of an event; away falls back to its second shirt
// (or a default) when the two are too close to tell apart.
export const resolveTeamColors = matchData => {
  const list = matchData?.competitors;
  const arr = Array.isArray(list) ? list : (list ? [list.home, list.away].filter(Boolean) : []);
  const find = pos => {
    const byPos = arr.find(c => String(c.position ?? c.Position ?? c.qualifier ?? '') === pos || String(c.qualifier ?? '').toLowerCase() === (pos === '1' ? 'home' : 'away'));
    if (byPos) return byPos;
    const id = pos === '1' ? matchData?.home_id : matchData?.away_id;
    const byId = id !== undefined && arr.find(c => String(c.id) === String(id));
    return byId || arr[pos === '1' ? 0 : 1] || null;
  };
  const h = find('1');
  const a = find('2');
  const home = normalizeHex(h?.shirtColorPrimary) || DEFAULT_HOME_COLOR;
  let away = normalizeHex(a?.shirtColorPrimary) || DEFAULT_AWAY_COLOR;
  if (colorDistance(home, away) < 70) {
    const alt = normalizeHex(a?.shirtColorSecondary);
    // Otherwise whichever default (red / celeste) contrasts more with home.
    const fallback = colorDistance(home, DEFAULT_AWAY_COLOR) >= colorDistance(home, DEFAULT_HOME_COLOR) ? DEFAULT_AWAY_COLOR : DEFAULT_HOME_COLOR;
    away = alt && colorDistance(home, alt) >= 70 ? alt : fallback;
  }
  return { home, away };
};
